/**
 * Single Source of Truth: Academic Foundations, Certifications & Algorithmic Rigor
 */

export const educationData = {
    degree: 'Bachelor of Technology in Computer Science & Engineering',
    field: 'Computer Science & Engineering',
    institution: 'Dr. B.C. Roy Engineering College',
    location: 'Durgapur, India',
    affiliation: 'MAKAUT Affiliated • AICTE Approved',
    tag: 'Accredited 4-Year Engineering Degree',
    period: 'July 2015 – August 2019',
    honor: 'Accredited 4-Year Engineering Degree',
    coreDisciplines: [
        'Data Structures & Algorithms',
        'Operating Systems',
        'Database Systems (DBMS)',
        'Computer Networks',
        'Compiler Design',
        'Cryptography & Security',
    ],
    theoreticalFoundations: [
        {
            area: 'Systems Concurrency & Kernel Architecture',
            detail: 'Multi-threaded synchronization, non-blocking event loops, CPU scheduling & memory isolation.',
        },
        {
            area: 'Database Engines & ACID Durability',
            detail: 'Relational normalization (BCNF), transaction serializability, B-Tree indexing & Write-Ahead Logging (WAL).',
        },
        {
            area: 'Network Transport & Protocol Security',
            detail: '7-layer OSI stack, TCP flow & congestion control, socket multiplexing & TLS cryptographic handshakes.',
        },
        {
            area: 'Algorithmic Complexity & Optimization',
            detail: 'Strict asymptotic Big-O runtime profiling, space-time tradeoffs, graph traversal & deterministic performance.',
        },
    ],
};

export const certificationsData = [
    {
        title: 'Full Stack Web Developer Nanodegree',
        issuer: 'Udacity',
        period: 'Aug 2018 – Jan 2019',
        tag: 'Credential Verified',
        skills: '6 Full-Stack Applications, Flask, PostgreSQL, REST APIs, RBAC Auth & Cloud Deployment',
    },
    {
        title: 'Microsoft Technology Associate (MTA)',
        issuer: 'Microsoft (Certiport)',
        period: '2017 – 2018',
        tag: 'Microsoft Certified',
        skills: 'Database Administration & Python Programming Fundamentals',
    },
];

export const competitiveProfiles = [
    {
        name: 'HackerRank',
        stat: '100+ Algorithms Solved',
        sub: 'Verified 6-Star Gold in Problem Solving & Python',
        link: 'https://www.hackerrank.com/devamitin',
        tag: '6-Star Gold',
    },
    {
        name: 'Codewars',
        stat: 'Top 10% Global Rank',
        sub: '200+ Complex Katas Solved (4 Kyu Master)',
        link: 'https://www.codewars.com/users/devamitin',
        tag: '4 Kyu Master',
    },
];

const qualificationsData = {
    educationData,
    certificationsData,
    competitiveProfiles,
};

export default qualificationsData;
